export { default as Cross } from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_cross.svg';
export { default as Search } from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_search.svg';
